import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { useHighFrequencyRefreshQuery } from '../../../queryDefaults/baseQueries/useHighFrequencyRefreshQuery';
import { PatientsApi } from '../../../apis/PatientsApi/PatientsApi.ts';

export function useGetPatientProfileSummary(patientId?: string) {
    return useHighFrequencyRefreshQuery({
        queryKey: [QueryKeys.patientProfileSummary, patientId],
        queryFn: async () => {
            return await PatientsApi.getPatientProfileSummary(patientId!);
        },
        enabled: !!patientId,
    });
}
